/**
 * ดาวน์โหลดข้อมูล — turns the rows already on screen into a CSV download.
 *
 * A UTF-8 BOM is prepended because Excel on Windows otherwise renders Thai as
 * mojibake, which is the only way anyone at the shop will open these.
 */
export function exportCsv(filename, columns, rows) {
  const escape = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const body = [
    columns.map((c) => escape(c.label)).join(','),
    ...rows.map((r) => columns.map((c) => escape(c.value(r))).join(',')),
  ].join('\n');

  const blob = new Blob([`﻿${body}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** พิมพ์ — opens a print window with a plain table of the same rows. */
export function printTable(title, columns, rows, subtitle = '') {
  const w = window.open('', '_blank', 'width=900,height=700');
  if (!w) return;

  const cell = (v) => String(v ?? '').replace(/[<>&]/g, (c) =>
    ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));

  w.document.write(`<!doctype html><html lang="th"><head><meta charset="utf-8">
    <title>${cell(title)}</title>
    <style>
      body { font-family: 'Noto Sans Thai', sans-serif; padding: 24px; color: #1f2937; }
      h1 { font-size: 18px; margin: 0 0 2px; }
      .sub { color: #6b7280; font-size: 12px; margin-bottom: 16px; }
      table { width: 100%; border-collapse: collapse; font-size: 12px; }
      th { text-align: left; border-bottom: 2px solid #e5e7eb; padding: 8px; }
      td { border-bottom: 1px solid #f3f4f6; padding: 8px; }
      .num { text-align: right; }
      @media print { @page { margin: 14mm; } }
    </style></head><body>
    <h1>${cell(title)}</h1><div class="sub">${cell(subtitle)}</div>
    <table><thead><tr>${columns.map((c) =>
      `<th class="${c.num ? 'num' : ''}">${cell(c.label)}</th>`).join('')}</tr></thead>
    <tbody>${rows.map((r) => `<tr>${columns.map((c) =>
      `<td class="${c.num ? 'num' : ''}">${cell(c.value(r))}</td>`).join('')}</tr>`).join('')}
    </tbody></table></body></html>`);

  w.document.close();
  w.focus();
  w.print();
}
